import React from 'react';
import { C, chip, pista } from './estilos';

/**
 * Columna izquierda: secciones con sus switches. Cada fila se puede elegir
 * (pinta su ejemplo a la derecha) y su switch cambia el valor en memoria.
 */


export const Interruptor = ({ on, onClick, disabled, label, tamano = 'normal' }) => {
  const chico = tamano === 'chico';
  const w = chico ? 28 : 44;
  const h = chico ? 16 : 26;
  const k = chico ? 12 : 20;
  const pad = chico ? 2 : 3;
  const trackStyle = {
    width: w, height: h, borderRadius: 999, border: 'none', padding: 0,
    position: 'relative', flexShrink: 0, background: pista(on),
    transition: 'background 300ms', cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
  };
  const knob = (
    <span
      style={{
        position: 'absolute', top: pad, left: on ? w - k - pad : pad,
        width: k, height: k, borderRadius: '50%', background: '#fff',
        transition: 'left 300ms', boxShadow: '0 1px 2px rgba(0,0,0,.2)',
      }}
    />
  );
  if (!onClick) {
    return <span aria-hidden="true" style={{ ...trackStyle, display: 'inline-block', cursor: 'default', opacity: 1 }}>{knob}</span>;
  }
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      title={disabled ? undefined : (on ? `Apagar "${label}"` : `Prender "${label}"`)}
      disabled={disabled}
      onClick={onClick}
      style={{ ...trackStyle, marginTop: 1 }}
    >
      {knob}
    </button>
  );
};

export const FilaSwitch = ({ item, on, servidor, guardando, bloqueado, cambiado, elegido, onElegir, onToggle, onRegresar }) => {
  const valorServidor = Boolean(servidor);
  const origenTexto = item.soloPanel
    ? 'se guarda en el panel'
    : cambiado
    ? `cambiado en panel · el servidor dice ${valorServidor ? 'prendido' : 'apagado'}`
    : 'valor del servidor';

  return (
    <div
      data-testid={`fila-${item.clave}`}
      onClick={() => onElegir(item.clave)}
      style={{
        display: 'flex', gap: 14, alignItems: 'flex-start', padding: 12, borderRadius: 16,
        cursor: 'pointer', transition: 'background 300ms, border-color 300ms',
        border: `1.5px solid ${elegido ? C.cyanBorde : 'transparent'}`,
        background: elegido ? C.cyanTinte : 'transparent',
      }}
    >
      <Interruptor
        on={on}
        label={item.titulo}
        disabled={!item.editable || bloqueado || Boolean(guardando)}
        onClick={(e) => { e.stopPropagation(); onToggle(item.clave); }}
      />
      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onElegir(item.clave); }}
            style={{
              border: 'none', background: 'none', padding: 0, cursor: 'pointer', textAlign: 'left',
              fontSize: 14.5, fontWeight: 600, color: C.ink, fontFamily: 'inherit',
            }}
          >
            {item.titulo}
          </button>
          {!item.editable && (
            <span style={chip(C.gris, C.apagado)}>
              <i className="pi pi-lock" style={{ fontSize: 10 }} />No se cambia aquí
            </span>
          )}
        </div>
        <div style={{ fontSize: 13.5, color: C.ink3, lineHeight: 1.45 }}>{item.queHace}</div>
        {item.nota && (
          <div style={{ fontSize: 12.5, color: C.steel, lineHeight: 1.4, display: 'flex', gap: 6, alignItems: 'baseline' }}>
            <i className="pi pi-info-circle" style={{ fontSize: 11 }} />{item.nota}
          </div>
        )}
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', fontSize: 12 }}>
          <span style={{ color: cambiado ? C.cyan : C.grisClaro, fontStyle: 'italic' }}>
            {guardando === item.clave ? 'Guardando…' : origenTexto}
          </span>
          {cambiado && !guardando && (
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); onRegresar(item.clave); }}
              style={{
                border: 'none', background: 'none', padding: 0, color: C.cyan, fontSize: 12,
                cursor: 'pointer', fontFamily: 'inherit', display: 'inline-flex', gap: 4, alignItems: 'center',
              }}
            >
              <i className="pi pi-undo" style={{ fontSize: 11 }} />Regresar al valor del servidor
            </button>
          )}
        </div>
      </div>
      <span
        style={{
          fontSize: 12, color: elegido ? C.cyan : C.grisClaro, display: 'flex', gap: 4,
          alignItems: 'center', marginTop: 5, whiteSpace: 'nowrap',
        }}
      >
        <i className="pi pi-comments" style={{ fontSize: 12 }} />{elegido ? 'Viendo' : 'Ver qué cambia'}
      </span>
    </div>
  );
};

export const SeccionSwitches = ({ seccion, valorDe, servidorDe, guardando, bloqueado, cambios, elegido, onElegir, onToggle, onRegresar, children }) => {
  const prendidos = seccion.switches.filter((s) => valorDe(s.clave)).length;
  return (
    <section
      aria-label={seccion.titulo}
      style={{ background: '#fff', borderRadius: 16, padding: '16px 16px 6px', display: 'flex', flexDirection: 'column', border: `1px solid ${C.lineaSuave}` }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4, padding: '0 4px 10px', borderBottom: `1px solid ${C.lineaSuave}`, marginBottom: 6 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
          <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: C.steel }}>{seccion.titulo}</h3>
          {seccion.switches.length > 0 && (
            <span style={{ fontSize: 12.5, color: C.gris, whiteSpace: 'nowrap' }}>
              {prendidos} de {seccion.switches.length} prendidos
            </span>
          )}
        </div>
        <p style={{ margin: 0, fontSize: 13.5, color: C.ink3, lineHeight: 1.45 }}>{seccion.descripcion}</p>
        {seccion.nota && (
          <div style={{ marginTop: 6, padding: '9px 12px', borderRadius: 10, background: '#EAF7FC', border: '1px solid #CBE7F4', fontSize: 12.5, color: '#1f6f8c', lineHeight: 1.45, display: 'flex', gap: 8 }}>
            <i className="pi pi-info-circle" style={{ fontSize: 12, marginTop: 2 }} />
            <span>{seccion.nota}</span>
          </div>
        )}
      </div>
      {seccion.switches.map((item) => (
        <FilaSwitch
          key={item.clave}
          item={item}
          on={valorDe(item.clave)}
          servidor={servidorDe(item.clave)}
          guardando={guardando}
          bloqueado={bloqueado}
          cambiado={item.clave in cambios}
          elegido={elegido === item.clave}
          onElegir={onElegir}
          onToggle={onToggle}
          onRegresar={onRegresar}
        />
      ))}
      {children}
    </section>
  );
};

export default SeccionSwitches;
